export const translateStatus = (status) => {
    if (!status) return '';
    const normalizedStatus = typeof status === 'string' ? status.toLowerCase() : '';
    
    switch (normalizedStatus) {
        case 'processing':
        case 'בתהליך עיבוד':
            return 'בתהליך עיבוד';
        case 'pending_goods_receipt':
            return 'ממתין לקבלת סחורה';
        case 'מאושר':
        case 'approved':
            return 'מאושר';
        case 'נדחה':
        case 'rejected':
            return 'נדחה';
        case 'pending_approval':
        case 'ממתין לאישור':
            return 'ממתין לאישור';
        case 'requires_attention':  
        case 'חשבונית להמשך טיפול':
            return 'חשבונית להמשך טיפול';
        case 'draft_in_priority':
            return 'אושר ונקלט';
        case 'pending_priority_creation':
        case 'pending priority creation': 
            return 'ממתין ליצירה בפריוריטי';
        case 'priority_creation_failed':
            return 'יצירה בפריוריטי נכשלה';
        case 'final':
        case 'סופית':
        case 'נסגרה בפריוריטי':
            return 'נסגרה בפריוריטי';
        case 'pending_retainer_allocation':
        case 'חשבונית ריטיינר - ממתין לשיוך הזמנות':
            return 'חשבונית ריטיינר - ממתין לשיוך הזמנות';
        default:
            if (normalizedStatus.includes('pending_priority') || 
                normalizedStatus.includes('priority_creation') ||
                status === 'PENDING_PRIORITY_CREATION') {
                return 'ממתין ליצירה בפריוריטי';
            }
            return status || '';
    }
};

export const isApprovedStatus = (status) => {
    if (!status) return false;
    const normalizedStatus = typeof status === 'string' ? status.toLowerCase() : '';
    return normalizedStatus === 'מאושר' ||
        normalizedStatus === 'approved' ||
        normalizedStatus.includes('approved');
};

export const isRejectedStatus = (status) => {
    if (!status) return false;
    const normalizedStatus = typeof status === 'string' ? status.toLowerCase() : '';
    return normalizedStatus === 'נדחה' ||
        normalizedStatus === 'rejected' ||
        normalizedStatus.includes('rejected');
};

export const isPendingPriorityStatus = (status) => {
    if (!status) return false;
    const normalizedStatus = typeof status === 'string' ? status.toLowerCase() : '';
    return normalizedStatus === 'ממתין ליצירה בפריוריטי' ||
        normalizedStatus === 'pending_priority_creation' ||
        normalizedStatus.includes('pending_priority') ||
        normalizedStatus.includes('priority_creation');
};

export const isRequiresAttentionStatus = (status) => {
    if (!status) return false;
    const normalizedStatus = typeof status === 'string' ? status.toLowerCase() : '';
    
    const requiresAttentionStatuses = [
        'requires_attention',
        'חשבונית להמשך טיפול',
        'שגיאה בח.פ החברה',
        'שגיאה בשם הספק',
        'מידע חסר',
        'שגיאה בעיבוד',
        'לא נמצא ח.פ',
        'שגיאה בהקצאה'
    ];
    
    return requiresAttentionStatuses.some(attentionStatus => 
        normalizedStatus === attentionStatus.toLowerCase() || 
        normalizedStatus.includes(attentionStatus.toLowerCase())
    );
};